import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './Auth.css';

import { API_BASE } from '../config/api';
import { jsonHeaders, parseApiError } from '../utils/apiClient';

const Register = () => {
  const [step, setStep] = useState('register');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phone: ''
  });
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/users/register`, {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStep('verify');
        setMessage('Registration successful! Please check your email for the OTP.');
      } else {
        setMessage(await parseApiError(response));
      }
    } catch (error) {
      setMessage('Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(
        `${API_BASE}/users/verify-email?email=${encodeURIComponent(formData.email)}&otp=${encodeURIComponent(otp)}`,
        { method: 'POST', headers: jsonHeaders }
      );

      if (response.ok) {
        setMessage('Email verified successfully! Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setMessage(await parseApiError(response));
      }
    } catch (error) {
      setMessage('Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setResending(true);
    setMessage('');

    try {
      const response = await fetch(
        `${API_BASE}/users/resend-otp?email=${encodeURIComponent(formData.email)}`,
        { method: 'POST', headers: jsonHeaders }
      );

      if (response.ok) {
        setMessage('A new OTP has been sent to your email');
      } else {
        setMessage(await parseApiError(response));
      }
    } catch (error) {
      setMessage('Failed to resend OTP. Please try again.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <Navigation />
      <div className="auth-container">
        {step === 'register' ? (
          <form onSubmit={handleRegister} className="auth-form">
            <h2>Register</h2>
            <input
              type="text"
              placeholder="First Name"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
            />
            <input
              type="tel"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Registering...' : 'Register'}
            </button>

            {message && (
              <p className={`message ${message.includes('successful') ? 'success' : 'error'}`}>
                {message}
              </p>
            )}

            <p className="auth-toggle">
              Already have an account?{' '}
              <a href="/login" className="toggle-link">
                Login here
              </a>
            </p>
          </form>
        ) : (
          <form onSubmit={handleVerify} className="auth-form">
            <h2>Verify Email</h2>
            <p>We sent a verification code to <strong>{formData.email}</strong></p>

            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value.toUpperCase())}
              required
              maxLength={10}
              autoComplete="one-time-code"
            />

            <button type="submit" disabled={loading || resending}>
              {loading ? 'Verifying...' : 'Verify Email'}
            </button>

            {message && (
              <p className={`message ${message.includes('success') || message.includes('sent') ? 'success' : 'error'}`}>
                {message}
              </p>
            )}

            <p className="auth-toggle">
              Didn't receive the code?{' '}
              <button
                type="button"
                className="toggle-link logout-btn"
                onClick={handleResendOtp}
                disabled={loading || resending}
              >
                {resending ? 'Sending...' : 'Resend OTP'}
              </button>
            </p>

            <p className="auth-toggle">
              Already verified?{' '}
              <a href="/login" className="toggle-link">
                Login here
              </a>
            </p>
          </form>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Register;
